import React from 'react';
import UIkit from 'uikit';
import produce from 'immer';
import { uniq, map, groupBy } from 'lodash';

export default class DealerList extends React.Component {

  state = {
    filter: this.getCurrentFilter(),
    tab: null
  }

  constructor(props) {
    super(props);

    window.addEventListener('hashchange', () => this.setState({ filter: this.getCurrentFilter() }));
  }

  render() {
    const { distributors } = this.props;
    const { filter, tab } = this.state;
    console.log("distributors are: ", distributors);
    const regionNames = ["United States", "Africa", "Asia", "Canada", "Central America + Caribbean", "Europe", "Middle East", "Oceania", "South America"];
    const stateNames = ['Alabama','Alaska','Arizona','Arkansas','California','Colorado','Connecticut','Delaware','Florida','Georgia','Hawaii','Idaho','Illinois','Indiana','Iowa','Kansas','Kentucky','Louisiana','Maine','Maryland','Massachusetts','Michigan','Minnesota','Mississippi','Missouri','Montana','Nebraska','Nevada','New Hampshire','New Jersey','New Mexico','New York','North Carolina','North Dakota','Ohio','Oklahoma','Oregon','Pennsylvania','Rhode Island','South Carolina','South Dakota','Tennessee','Texas','Utah','Vermont','Virginia','Washington','West Virginia','Wisconsin','Wyoming'];
    const regionsMap = document.querySelector('[data-image-map="regions"]');
    const statesMap = document.querySelector('[data-image-map="states"]');
    const regions = uniq(distributors.map(d => d.dealer_region_reference__c));
    const states = uniq(distributors.map(d => d.dealer_country_reference__c));

    const regionShapes = map(regionsMap.querySelectorAll('.imp-shape'), (el) => {
        return el.dataset.shapeTitle;
      });

    const stateShapes = map(statesMap.querySelectorAll('.imp-shape'), (el) => {
        return el.dataset.shapeTitle;
      });

    const filterIsRegion = regions.includes(filter);
    const filterIsCountry = !filterIsRegion && states.includes(filter);
    const filteredDistributors = filterIsRegion ?
      distributors.filter(d => d.dealer_region_reference__c === filter) :
      (filterIsCountry ? distributors.filter( d => d.dealer_country_reference__c === filter) : []);

    const regionsForFilteredDistributors = uniq(filteredDistributors.map(d => d.dealer_region_reference__c));
    const statesForFilteredDistributors = uniq(filteredDistributors.map(d => d.dealer_country_reference__c));

    const isUSA = filter === "United States";
    const allAreSameRegion = regionsForFilteredDistributors.length === 1;
    const allAreSameCountry = statesForFilteredDistributors.length === 1;
    const hasResults = (allAreSameRegion && !filterIsCountry && !isUSA) || (filterIsCountry && allAreSameCountry);

    const selectedRegion = allAreSameRegion ? regionsForFilteredDistributors[0] : null;
    const distributorsForSelectedRegion = distributors.filter(d => d.dealer_region_reference__c === selectedRegion);

    const showStatesSelect = (isUSA || stateShapes.includes(filter) || filterIsCountry);

    const statesForSelectedRegion = selectedRegion && uniq(distributorsForSelectedRegion.map(d => d.dealer_country_reference__c));

    const tabs = uniq(filteredDistributors.map(d => d.account_type_reference__c)).sort()
    const selectedTab = tabs.includes(tab) ? tab : tabs[0];
    const filteredDistributorsForTab = filteredDistributors
      .filter(d => d.account_type_reference__c === selectedTab);

    console.log("filteredDistributorsForTab are: ", filteredDistributorsForTab)

    const sortedFilteredDistributorsForTab = Object.values(groupBy(filteredDistributorsForTab, "dealer_country_reference__c")).reduce( (acc, curr) => (
        [...acc, curr.slice().sort((a,b) => (new Date(b.createddate) - new Date(a.createddate)))].flat()
    ), [] );

    console.log("sortedFilteredDistributorsForTab are: ", filteredDistributorsForTab);

    const regionSelect = document.querySelector('.js-region-select');
    const stateSelect = document.querySelector('.js-state-select');

    regionSelect.innerHTML = "<option>Select a region</option>" +
      regionNames.map(r => `<option value="${r}" ${r === filter ? 'selected' : ''}>${r}</option>`);
    if (showStatesSelect && statesForSelectedRegion && statesForSelectedRegion.length > 0) {
      stateSelect.innerHTML = "<option>Select a state</option>" +
        stateNames.map(r => (
          `<option value="${r}" ${r === filter ? 'selected' : ''}>${r}</option>`
        ));
    }

    const hasFilter = filter && filter !== "United States";

    document.querySelector('.js-states-back').style.display = (showStatesSelect ? 'block' : 'none');

    return (
      <div className="uk-margin-large-bottom">

        { hasFilter &&
          <h3 className="uk-text-center">Contact a {showStatesSelect && "U.S."} Representative</h3>
        }

        { hasFilter &&
          <div className="uk-width-1-2 uk-margin-auto uk-text-center">
            <p><strong>If you can't locate a representative for your area, <a href="/contact-us">contact us</a> directly for more information about purchasing Plasma Air products.</strong></p>
          </div>
        }

        { hasResults && tabs.length > 1 &&
          <div className="uk-margin-auto uk-margin-medium-top">
            <ul className="uk-flex-center uk-tab js-tab-filters">
              {tabs.map(tab => (
                <li key={tab} className={tab === selectedTab ? 'uk-active' : ''}>
                  <a onClick={() => this.setState({ tab })}>{tab}</a>
                </li>
              ))}
            </ul>
          </div>
        }

        { hasResults && filteredDistributors.length > 0 &&
          <div className="uk-section uk-section-small">
            <div className="uk-container">
              <div uk-grid="true" className="uk-child-width-1-1 uk-child-width-1-2@s uk-child-width-1-3@m uk-grid-medium uk-grid-match uk-flex uk-flex-center js-dealers-by-country">
                {sortedFilteredDistributorsForTab.map(distributor => (
                  <div key={distributor.id} className="uk-animation-fade">
                    <div className="uk-card uk-card-default uk-height-1-1">
                      <div className="uk-card-body">
                        <h6 className="uk-text-warning uk-margin-small-bottom">{ distributor.dealer_country_reference__c }</h6>
                        <h3 className="uk-margin-remove-top">{ distributor.name }</h3>
                        <hr uk-margin="true" />
                        <div className="">
                          <ul className="uk-list">
                            { distributor.dealer_primary_phone_reference__c &&
                              <li>Tel: { distributor.dealer_primary_phone_reference__c }</li>
                            }
                            { distributor.dealer_fax_reference__c &&
                              <li>Fax: { distributor.dealer_fax_reference__c }</li>
                            }
                            { distributor.dealer_primary_email_reference__c &&
                              <li>Email: { distributor.dealer_primary_email_reference__c }</li>
                            }
                            { distributor.dealer_website_url_reference__c &&
                              <li><a href={ distributor.dealer_website_url_reference__c } target="_blank">{ distributor.dealer_website_url_reference__c }</a></li>
                            }
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        }
      </div>
    )
  }

  getCurrentFilter() {
    const hash = window.location.hash
      .split("#")
      .filter(f => f !== "")
      .map(gF => decodeURI(gF))[0];
    return (hash && hash !== "all") ? hash : undefined;
  }
}
